import apiService from '../http.service';
import { appConfig } from '../../app.config';

class MaterialTabService {

  getConcreteStrength() {
    return apiService.get({ query: appConfig.path.CONCRETE_STRENGTH });
  }

  getConcreteStrengthValue(concreteStrength) {
    return apiService.get({ query: `${appConfig.path.CONCRETE_STRENGTH_VALUE}?concreteStrength=${concreteStrength}` });
  }

  getConcreteConditions() {
    return apiService.get({ query: appConfig.path.CONCRETE_CONDITIONS });
  }

  getBondConditions() {
    return apiService.get({ query: appConfig.path.BOND_CONDITIONS });
  }

  getPlateReinforcement() {
    return apiService.get({ query: appConfig.path.PLATE_REINFORCEMENT });
  }

  getEdgeReinforcement() {
    return apiService.get({ query: appConfig.path.EDGE_REINFORCEMENT })
      .then((list) => {
        list.forEach(item => item.RunName = item.RunName.replace('&lt;', '<'));
        return list;
      });
  }

  getInstallationConditions() {
    return apiService.get({ query: appConfig.path.INSTALLATION_CONDITIONS });
  }

  getInstallationConditionsAnchors () {
    return apiService.get({ query: appConfig.path.INSTALLATION_CONDITIONS_ANCHORS });
  }

  getRangeTemperature() {
    return apiService.get({ query: appConfig.path.RANGE_TEMPERATURE });
  }

  getHoleConditions() {
    return apiService.get({ query: appConfig.path.HOLE_CONDITIONS });
  }

  getTensionLoadConditions() {
    return apiService.get({ query: appConfig.path.TENSION_LOAD_CONDITIONS });
  }

  getShearLoadConditions() {
    return apiService.get({ query: appConfig.path.SHEAR_LOAD_CONDITIONS });
  }

  getLongTermTemperature() {
    return apiService.get({ query: appConfig.path.LONG_TERM_CONDITIONS });
  }

  getShortTermTemperature() {
    return apiService.get({ query: appConfig.path.SHORT_TERM_CONDITIONS });
  }

  getMasonryServiceTemperature() {
    return apiService.get({ query: appConfig.path.MASONRY_SERVICE_TEMPERATURE });
  }

  getMasonryMaterials() {
    return apiService.get({ query: appConfig.path.MASONRY_MATERIALS });
  }

  getMasonryMaterialInfo(InternalName) {
    return apiService.get({ query: `${appConfig.path.MASONRY_MATERIAL_INFO}?materialInternalName=${encodeURIComponent(InternalName)}` });
  }

  getMasonryMaterialDesignResistance(data) {
    return apiService.post({
      query: appConfig.path.MASONRY_MATERIAL_DESIGN_RESISTANCE,
      data: {
        testResults: data.map(i => ({
          N: i.tensile,
          V: i.shear
        }))
      }
    }).then(res => {
      if (res) {
        return {
          n1Test: res.N,
          v1Test: res.V
        };
      }
    });
  }

  getMasonryProducts() {
    return apiService.get({ query: appConfig.path.MASONRY_PRODUCTS });
  }

  getMasonrySizes(InternalName) {
    return apiService.get({ query: `${appConfig.path.MASONRY_SIZES}?anchorInternalName=${encodeURIComponent(InternalName)}` });
  }

  getMaterialWoodConnection() {
    return apiService.get({ query: appConfig.path.WOOD_CONNECTION_MATERIALS });
  }

}

export default new MaterialTabService();



// WEBPACK FOOTER //
// ./src/services/requests/material-tab.service.js